import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ObservationsTable = () => {
  const [observations] = useState([
    {
      id: 'OBS-2025-001',
      type: 'Unsafe Act',
      severity: 'High',
      location: 'Plant 1 - Assembly Line',
      reporter: 'John Smith',
      assignedTo: 'Safety Team A',
      status: 'In Progress',
      daysOpen: 3,
      statusColor: 'text-blue-500'
    },
    {
      id: 'OBS-2025-002',
      type: 'Unsafe Condition',
      severity: 'Critical',
      location: 'Plant 2 - Storage Area',
      reporter: 'Sarah Johnson',
      assignedTo: 'Safety Team B',
      status: 'Overdue',
      daysOpen: 12,
      statusColor: 'text-red-500'
    },
    {
      id: 'OBS-2025-003',
      type: 'Unsafe Act',
      severity: 'Medium',
      location: 'Plant 1 - Loading Dock',
      reporter: 'Mike Davis',
      assignedTo: 'Safety Team A',
      status: 'Rectified',
      daysOpen: 5,
      statusColor: 'text-green-500'
    },
    {
      id: 'OBS-2025-004',
      type: 'Unsafe Condition',
      severity: 'High',
      location: 'Warehouse 1',
      reporter: 'Emily Chen',
      assignedTo: 'Maintenance Team',
      status: 'Reported',
      daysOpen: 1,
      statusColor: 'text-gray-500'
    }
  ]);

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Critical':
        return 'text-red-500 bg-red-500/10';
      case 'High':
        return 'text-orange-500 bg-orange-500/10';
      case 'Medium':
        return 'text-yellow-500 bg-yellow-500/10';
      default:
        return 'text-gray-500 bg-gray-500/10';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Recent Observations</h3>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Severity
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Location
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Assigned To
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Days Open
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {observations?.map((obs) => (
              <tr key={obs?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-foreground">
                  {obs?.id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {obs?.type}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getSeverityColor(obs?.severity)}`}>
                    {obs?.severity}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-foreground">
                  {obs?.location}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {obs?.assignedTo}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`text-sm font-medium ${obs?.statusColor}`}>
                    {obs?.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {obs?.daysOpen} days
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <button className="text-primary hover:text-primary/80 transition-colors">
                    <Icon name="Eye" size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ObservationsTable;